import { ComponentPropsWithoutRef, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

interface SectionProps extends HTMLAttributes<HTMLDivElement> {}

const DetailSection = ({ children, className, ...props }: SectionProps) => {
    return (
        <div className={twMerge('flex', className)} {...props}>
            {children}
        </div>
    );
};

interface DetailProps extends ComponentPropsWithoutRef<'div'> {}

const DetailSectionTitle = ({ children, className, ...props }: DetailProps) => (
    <div className={twMerge('w-24 text-gray-500', className)} {...props}>
        {children}
    </div>
);

const DetailSectionContent = ({ children, className, ...props }: DetailProps) => (
    <div className={twMerge('flex w-full flex-col gap-2', className)} {...props}>
        {children}
    </div>
);

const DetailRow = ({ children, className, ...props }: DetailProps) => {
    return (
        <div className={twMerge('flex flex-col gap-2 pb-2', className)} {...props}>
            {children}
        </div>
    );
};

const DetailRowTitle = ({ children, className, ...props }: DetailProps) => (
    <div className={twMerge('font-semibold', className)} {...props}>
        {children}
    </div>
);

const Root = DetailSection;
const Title = DetailSectionTitle;
const Content = DetailSectionContent;
const Row = DetailRow;
const RowTitle = DetailRowTitle;

export {
    DetailSection,
    DetailSectionTitle,
    DetailSectionContent,
    DetailRow,
    DetailRowTitle,
    //
    Root,
    Title,
    Content,
    Row,
    RowTitle,
};
